// extracted by mini-css-extract-plugin
export default {"button":"button_button__Dn29P","big":"button_big__AUCSz","medium":"button_medium__clOht","small":"button_small__xd-cg"};